module.exports = __webpack_public_path__ + "static/media/activityTypePill-assignment.0b38bb47.svg";